export interface FormioAlert {
  type: string;
  message: string;
}

export class FormioAlerts {
  public alerts: FormioAlert[] = [];
  setAlert(alert: FormioAlert) {
    this.alerts = [alert];
  }
  addAlert(alert: FormioAlert) {
    this.alerts.push(alert);
  }
  setAlerts(alerts: FormioAlert[]) {
    this.alerts = alerts;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/formio.alerts.ts